<section class="photo-capture">
  @if (!cameraEnabled) {
    <button
      class="photo-capture__enable"
      type="button"
      (click)="enableCamera()"
      [disabled]="startingCamera"
    >
      <i class="fa-solid fa-camera"></i>

      {{ startingCamera ? 'Iniciando cámara...' : 'Activar cámara' }}
    </button>
  }

  @if (cameraEnabled) {
    <div class="photo-capture__camera">
      <video #videoElement autoplay playsinline muted></video>

      <canvas #canvasElement class="photo-capture__canvas"></canvas>

      @if (flashSupported) {
        <button
          class="photo-capture__flash"
          type="button"
          [class.photo-capture__flash--on]="flashEnabled"
          (click)="toggleFlash()"
          [attr.aria-pressed]="flashEnabled"
          [title]="flashEnabled ? 'Apagar flash' : 'Encender flash'"
        >
          <i class="fa-solid" [class.fa-bolt]="flashEnabled" [class.fa-bolt-slash]="!flashEnabled"></i>
        </button>
      }

      <div class="photo-capture__controls">
        <button class="photo-capture__close" type="button" (click)="disableCamera()">
          <i class="fa-solid fa-xmark"></i>
        </button>

        <button
          class="photo-capture__capture"
          type="button"
          (click)="capturePhoto()"
          [disabled]="!cameraReady || photos.length >= maxPhotos"
        >
          <span></span>
        </button>
      </div>
    </div>
  }

  @if (cameraError) {
    <small class="photo-capture__error">
      {{ cameraError }}
    </small>
  }

  <div class="photo-capture__gallery">
    @for (photo of photos; track $index) {
      <figure class="photo-capture__item">
        <img [src]="photo.previewUrl" alt="Foto evidencia" />

        <button type="button" (click)="removePhoto($index)">
          <i class="fa-solid fa-trash"></i>
        </button>
      </figure>
    }
  </div>
</section>
